'use client';

import { ErrorScreen } from '@modules/shared/components/status-screens/error-screen/error-screen';

import * as React from 'react';

const ForbiddenScreen: React.FC = () => (
  <ErrorScreen
    headline='403'
    title="You don't have access to this page."
    data-testid='forbidden-screen'
  />
);

export { ForbiddenScreen };
